import { useState, useEffect } from "react";
import { loadConnectAndInitialize, StripeConnectInstance } from "@stripe/connect-js";

export const useStripeConnect = (connectedAccountId: string | undefined): StripeConnectInstance | undefined => {
  const [stripeConnectInstance, setStripeConnectInstance] = useState<StripeConnectInstance | undefined>(undefined);

  useEffect(() => {
    if (connectedAccountId) {
      const fetchClientSecret = async () => {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/stripe-connect/account_session`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            account: connectedAccountId,
          }),
        });

        if (!response.ok) {
          // Handle errors on the client side here
          const { error } = await response.json();
          throw new Error(`An error occurred: ${error}`);
        } else {
          const { client_secret: clientSecret } = await response.json();
          return clientSecret;
        }
      };

      const initializeStripe = async () => {
        try {
          const instance = await loadConnectAndInitialize({
            publishableKey: process.env.REACT_APP_STRIPE_CONNECT_KEY || '',
            fetchClientSecret,
            appearance: {
              overlays: "dialog",
              variables: {
                colorPrimary: "#635BFF",
              },
            },
          });
          setStripeConnectInstance(instance);
        } catch (error) {
          console.error('Failed to initialize Stripe Connect:', error);
        }
      };

      initializeStripe();
    }
  }, [connectedAccountId]);

  return stripeConnectInstance;
};

export default useStripeConnect;